import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'input-time',
  templateUrl: 'inputTime.component.html',
  styleUrls: ['inputTime.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTimeComponent),
      multi: true,
    },
  ],
})
export class InputTimeComponent extends ControlValueAccessorDirective {
  @Input() placeholder: string = '';
  @Input() public readonly: boolean = false;
  @Input() minTime: string = '';
  constructor() {
    super();

  }
}
